import React from "react";
import { defaultTitle } from "../../config";
import { Helmet } from "react-helmet";

export const HelmetUtil = ({
  title,
  defaultTitleOverride = defaultTitle,
  children,
  ...props
}) => {
  return (
    <Helmet {...props}>
      <title>
        {title} - {defaultTitleOverride}
      </title>
      {children}
    </Helmet>
  );
};
